const readinessByCacheKey = new Map<string, boolean>();
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

export const registerToothSliceCard = (cacheKey: string) => {
  if (readinessByCacheKey.has(cacheKey)) {
    return;
  }

  readinessByCacheKey.set(cacheKey, false);
  notify();
};

export const unregisterToothSliceCard = (cacheKey: string) => {
  if (readinessByCacheKey.delete(cacheKey)) {
    notify();
  }
};

export const markToothSliceCardSettled = (cacheKey: string) => {
  if (readinessByCacheKey.get(cacheKey) === false) {
    readinessByCacheKey.set(cacheKey, true);
    notify();
  }
};

export const getToothSliceCardReadiness = () => ({
  registeredCount: readinessByCacheKey.size,
  settledCount: [...readinessByCacheKey.values()].filter(Boolean).length,
});

export const subscribeToToothSliceCards = (listener: () => void) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};
